module.exports = __webpack_public_path__ + "static/media/20191107.c9d5a415.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20191107/img/20191107.png
// module id = 300
// module chunks = 0